import { useMemo } from 'react';

import { useTenantSettingsStore } from '@/common/context/TenantSettingsStore';
import { deriveOrbPalette, type OrbPaletteStops } from '@/common/theme/orbPalette';

/**
 * Resolve tenant orb artwork stops once per theme version.
 */
export function useOrbPalette(): OrbPaletteStops {
  const theme = useTenantSettingsStore((state) => state.settings?.theme);
  const themeVersion = useTenantSettingsStore((state) => state.themeVersion);

  return useMemo(
    () => deriveOrbPalette({
      primaryColor: theme?.primaryColor ?? '#A9D14C',
      secondaryColor: theme?.secondaryColor ?? '#5FB5D9',
      accentColor: theme?.accentColor ?? '#4A4A4A',
    }),
    // themeVersion intentionally busts the cache when tenant theme is regenerated.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [theme?.primaryColor, theme?.secondaryColor, theme?.accentColor, themeVersion],
  );
}
